import { render, staticRenderFns } from "./AdvHedgeApp.vue?vue&type=template&id=07452555&scoped=true&"
import script from "./AdvHedgeApp.vue?vue&type=script&lang=js&"
export * from "./AdvHedgeApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07452555",
  null
  
)

export default component.exports